import "./App.css";
import Snail from "./Components/Snail";

function App() {
  return (
    <div className="App">
      <div className="num">
        <Snail />
      </div>
    </div>
  );
}

export default App;
